<template>
  <div class="project">
    <!-- Navbar -->
    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img id="navbar-logo" src="../../assets/projects/oi7/openInnovationMinor.jpg" alt="Logo">
      </div>
    </nav>

    <!-- Header Section -->
    <section class="project-section">
      <h2>Wacky Wednesday: A Journey of Creativity and Innovation</h2>
      <p>
        Explore the world of "Wacky Wednesday," a game development adventure where creativity knows no bounds and innovation is the name of the game. Join us on a journey through the unique vision of this whimsical project.
      </p>
    </section>

    <!-- Section 1 -->
    <section class="project-section">
      <h2>Blender: Crafting Unique Models</h2>
      <p>
        Our journey begins in Blender, where we craft a variety of models for the game. From player characters with quirky styles to NPCs inspired by friends, and fearsome enemy monsters with distinctive traits, our creativity knows no bounds. We also fashion buildings and environmental objects to bring the game world to life.
      </p>
      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image11.gif" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image24.gif" alt="Image 3">
        </figure>
      </div> 
    </div>
  </div>
  <br>
    </section>

    <!-- Section 2 -->
    <section class="project-section">
      <h2>Unity: The Engine of Imagination</h2>
      <p>
        Transitioning into Unity, we explore the intricacies of the game engine. Our journey is filled with experimentation, from creating character controllers and implementing animations to refining the camera system. We are on a quest to master Unity's intricacies and bring our vision to life.
      </p>
      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-full">
        <figure class="image">
          <img src="../../assets/projects/oi7/image9.gif" alt="Image 1">
        </figure>
      </div> 
    </div>
  </div>
  <br>
    </section>

    <!-- Section 3 -->
    <section class="project-section">
      <h2>A Fresh Unity Start and Musical Inspirations</h2>
      <p>
        Our game development journey takes a fresh start as we refine our project and introduce an improved lighting setup. We also delve into the world of Lo-Fi music, drawing inspiration from our love for this genre to create a fitting soundtrack for the game. Our determination to learn and innovate shines through as we tackle the challenges of game development.
      </p>
      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image29.gif" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image8.gif" alt="Image 3">
        </figure>
      </div> 
    </div>
  </div>
  <br>
    </section>

    <!-- Section 4 -->
    <section class="project-section">
      <h2>The New Game Scene: Building an Island</h2>
      <p>
        Our game comes to life as we construct a dynamic game world with 16 interactive tiles, a stunning skybox, and mesmerizing low-poly water effects. The island serves as the canvas for our creativity, where players can explore, interact, and uncover hidden treasures.
      </p>
      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image18.gif" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image8.gif" alt="Image 3">
        </figure>
      </div> 


    </div>
  </div>
  <br>
    </section>

    <!-- Section 5 -->
    <section class="project-section">
      <h2>Evolving Gameplay with Scripts</h2>
      <p>
        Incorporating scripts like wavesController and spawnObjects, we infuse life into the game world. The wavesController script breathes life into the sea, while spawnObjects orchestrates the dynamic placement of objects within the game. These scripts add depth and immersion to the player experience.
      </p>
      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      

      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image27.gif" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image26.gif" alt="Image 3">
        </figure>
      </div> 

    </div>
  </div>
  <br>
    </section>

    <!-- Section 6 -->
    <section class="project-section">
      <h2>ObjectClicker and Inventory System: Crafting and Collecting</h2>
      <p>
        The ObjectClicker script allows players to interact with the environment, chopping trees, mining stones, and gathering resources. We are also building an inventory system, setting the stage for crafting and resource management in the game.
      </p>
    
    </section>

    <!-- Section 7 -->
    <section class="project-section">
      <h2>Inspiration and Future Goals</h2>
      <p>
        Our inspiration is drawn from games like "Forager," where resource gathering and crafting lead to an ever-expanding world. With an eye on the future, we are driven to build a crafting and survival game that captivates players and sparks their creativity.
      </p>

      <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image25.png" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/oi7/image4.png" alt="Image 3">
        </figure>
      </div> 
    </div>
  </div>
  <br>

    </section>

    <!-- Section 8 -->
    <section class="project-section">
      <h2>Retrospective: A Journey of Learning</h2>
      <p>
        As the semester progresses, we reflect on our progress and the knowledge we have gained. We find joy in overcoming challenges and look forward to future endeavors, including an upcoming internship where we will apply our Unity skills.
      </p>
    </section>

    <!-- Conclusion -->
    <section class="project-section">
      <h2>Conclusion: "Wacky Wednesday" - An Ever-Evolving Journey</h2>
      <p>
        In "Wacky Wednesday," our creative spirit and dedication shine as we embark on a whimsical journey in game development. Our decision to venture into new territories, building a vibrant city full of life, NPC quests, and personal connections, adds a fresh layer of complexity and immersion to the project. Stay tuned for more adventures in this vibrant and imaginative world, where the line between reality and virtuality blurs in the most captivating ways. Our game is not just a game; it's a living, breathing world ready to be explored and cherished by players around the globe.
      </p>
    </section>

    <br>
    <div class="photo-grid">
    <div class="columns is-multiline">
      
      <div class="column is-full">
          <video src="../../assets/projects/oi7/finalvid.mp4" muted controls autoplay></video>        
      </div>
    </div>
  </div>
  <br><br>
    
  </div>
</template> 

<style scoped>
  @import 'project.css';
</style>